"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StaticJsonRpcBatchProvider = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _properties = require("@ethersproject/properties");
var _web = require("@ethersproject/web");
var _RpcProvider = require("./RpcProvider");
/**
 * This is based on the official ethers.js batch provider, with a few minor changes:
 *
 * - It's a static provider, so no network changes.
 * - There is no additional delay in the batching, since all requests are queued
 *   synchronously.
 */
class StaticJsonRpcBatchProvider extends _RpcProvider.RpcProvider {
  constructor(...args) {
    super(...args);
    (0, _defineProperty2.default)(this, "_pendingBatchAggregator", void 0);
    (0, _defineProperty2.default)(this, "_pendingBatch", void 0);
  }
  send(method, params) {
    const request = {
      method: method,
      params: params,
      id: this._nextId++,
      jsonrpc: "2.0"
    };
    if (this._pendingBatch == null) {
      this._pendingBatch = [];
    }
    const inflightRequest = {
      request,
      resolve: null,
      reject: null
    };
    const promise = new Promise((resolve, reject) => {
      inflightRequest.resolve = resolve;
      inflightRequest.reject = reject;
    });
    this._pendingBatch.push(inflightRequest);
    this.emit("debug", {
      action: "send",
      request: (0, _properties.deepCopy)(request),
      provider: this
    });
    if (!this._pendingBatchAggregator) {
      // Schedule batch for next event loop
      this._pendingBatchAggregator = setTimeout(() => {
        // Get teh current batch and clear it, so new requests
        // go into the next batch
        const batch = this._pendingBatch;
        this._pendingBatch = null;
        this._pendingBatchAggregator = null;

        // Get the request as an array of requests
        const request = batch.map(inflight => inflight.request);
        this.emit("debug", {
          action: "requestBatch",
          request: (0, _properties.deepCopy)(request),
          provider: this
        });
        return (0, _web.fetchJson)(this.connection, JSON.stringify(request)).then(result => {
          this.emit("debug", {
            action: "response",
            request: request,
            response: result,
            provider: this
          });

          // For each result, feed it to the correct Promise, depending
          // on whether it was a success or error
          batch.forEach((inflightRequest, index) => {
            const payload = result[index];
            if (payload.error) {
              const error = new Error(payload.error.message);
              error.code = payload.error.code;
              error.data = payload.error.data;
              inflightRequest.reject(error);
            } else {
              inflightRequest.resolve(payload.result);
            }
          });
        }, error => {
          this.emit("debug", {
            action: "response",
            error: error,
            request: request,
            provider: this
          });
          batch.forEach(inflightRequest => {
            inflightRequest.reject(error);
          });
        });
      }, 0);
    }
    return promise;
  }
}
exports.StaticJsonRpcBatchProvider = StaticJsonRpcBatchProvider;
//# sourceMappingURL=StaticJsonRpcBatchProvider.js.map